module.exports = __webpack_public_path__ + "static/img/rank_69.62322fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_69.png
// module id = ZtV7
// module chunks = 1